const styles = `:host {
  color: var(--goto-datatable-cell-color, var(--goto-text-01));
  display: table-cell;
  font: var(--goto-datatable-cell-font, var(--goto-body-small));
  padding: 0 1rem;
  vertical-align: middle;
}
:host ::slotted(chameleon-checkbox) {
  margin-top: 0.1875rem;
}`; export default styles;